import i18n from 'i18n';
import { FILE_SIZES } from 'helpers/variables';

export const getCustomValidator = ({
	currentSize,
	maxTotalSize,
	maxSizePerFile,
	allowedMimes
}) => (file) => {
	if (!allowedMimes.includes(file?.type)) {
		return {
			code: 'invalid-mime',
			message: i18n.t('contact_form_error_invalid_mime')
		};
	}
	if (maxTotalSize && currentSize + file?.size > maxTotalSize) {
		return {
			code: 'total-size-used',
			message: i18n.t('contact_form_error_total_size_too_large', {
				size: bytesToSize(maxTotalSize)
			})
		};
	}
	if (maxSizePerFile && file?.size > maxSizePerFile) {
		return {
			code: 'item-size-used',
			message: i18n.t('contact_form_error_item_size_too_large', {
				currentSize: bytesToSize(file?.size),
				maxSize: bytesToSize(maxSizePerFile)
			})
		};
	}
};

export const excludedErrors = ['file-invalid-type'];

export const bytesToSize = (bytes) => {
	if (bytes === 0) return '0 Byte';
	const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
	return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + FILE_SIZES[i];
};
